// @ts-nocheck
import {
  SET_TABLE_COLUMN_VISIBILITY,
  RESET_TABLE_COLUMN_VISIBILITY,
  INITIALIZE_TABLE_COLUMNS,
} from "../constants/tableColumnVisibility";

export const initializeTableColumns = (tableId, visibility) => ({
  type: INITIALIZE_TABLE_COLUMNS,
  payload: {
    tableId,
    visibility,
  },
});

export const setTableColumnVisibility = (tableId, visibility) => ({
  type: SET_TABLE_COLUMN_VISIBILITY,
  payload: {
    tableId,
    visibility,
  },
});

export const resetTableColumnVisibility = (tableId, visibility) => ({
  type: RESET_TABLE_COLUMN_VISIBILITY,
  payload: {
    tableId,
    visibility,
  },
});